/* PawDent — מתנות אוטומטיות: מעל סף הקנייה נוספים המדריכים לעגלה, ומתחתיו הם מוסרים.
   ההנחה עצמה (100% על פריטי הקולקציה) היא הנחת BXGY אוטומטית בשופיפיי — הסקריפט
   רק דואג שהפריטים יהיו בעגלה. הקונפיגורציה מוזרמת מ-snippets/cart-drawer.liquid
   דרך data-pdg-config על תגית הסקריפט. */
(function () {
  'use strict';
  if (window.__pdGiftsInit) return;
  window.__pdGiftsInit = true;

  var config = { threshold: 29900, gifts: [] };
  try {
    var el = document.currentScript || document.querySelector('script[data-pdg-config]');
    if (el && el.dataset.pdgConfig) config = JSON.parse(el.dataset.pdgConfig);
  } catch (err) { return; }
  if (!config.gifts || !config.gifts.length) return;

  var busy = false;
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

  function sectionNames() {
    var names = [];
    if (document.querySelector('cart-drawer')) names.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) names.push('cart-icon-bubble');
    return names;
  }

  function renderSections(data) {
    if (!data || !data.sections) return;
    if (data.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections['cart-drawer']) {
      // renderContents גם פותח את המגירה — כאן רק מרעננים תוכן, בלי לפתוח
      var inner = document.getElementById('CartDrawer');
      try {
        var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        var fresh = parsed.getElementById('CartDrawer');
        if (inner && fresh) inner.innerHTML = fresh.innerHTML;
      } catch (err) {}
    }
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftIds = config.gifts.map(Number);
        var eligible = 0;
        var inCart = {};
        (cart.items || []).forEach(function (item) {
          if (giftIds.indexOf(item.variant_id) > -1) inCart[item.variant_id] = item.quantity;
          else eligible += item.final_line_price;
        });
        var over = eligible >= config.threshold;

        if (over) {
          var toAdd = giftIds.filter(function (id) { return !inCart[id]; });
          var clamp = giftIds.filter(function (id) { return inCart[id] > 1; });
          if (clamp.length) {
            var updates = {};
            clamp.forEach(function (id) { updates[id] = 1; });
            return fetch(root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function () { busy = false; sync(); });
          }
          if (!toAdd.length) { busy = false; return; }
          var body = {
            items: toAdd.map(function (id) { return { id: id, quantity: 1 }; }),
            sections: sectionNames(),
            sections_url: window.location.pathname
          };
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          })
            .then(function (r) { return r.json(); })
            .then(function (data) { renderSections(data); busy = false; });
        }

        var present = giftIds.filter(function (id) { return inCart[id]; });
        if (!present.length) { busy = false; return; }
        var removals = {};
        present.forEach(function (id) { removals[id] = 0; });
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: removals, sections: sectionNames(), sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) { renderSections(data); busy = false; });
      })
      .catch(function () { busy = false; });
  }

  var timer = null;
  function queueSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  // מאזינים לכל פעולת עגלה באתר (הוספות מהבוקס, מהגריד, מהמגירה עצמה)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/') > -1 && url.indexOf('cart.js') === -1) {
      p.then(function () { queueSync(); }).catch(function () {});
    }
    return p;
  };
  document.addEventListener('cart:refresh', queueSync);

  if (document.readyState !== 'loading') queueSync();
  else document.addEventListener('DOMContentLoaded', queueSync);
})();
